import { InlineNotification } from "@carbon/react";
import React from "react";

export type ToastType = {
  id: string;
  title: string;
  subtitle: string;
  kind?: "error" | "info" | "info-square" | "success" | "warning" | "warning-alt";
};

export type ToastProps = ToastType & {
  onclose(): void;
};
const Toast: React.FC<ToastProps> = ({ id, kind, title, subtitle, onclose }) => {
  return (
    <InlineNotification
      key={id}
      onClose={onclose}
      className="mb-5"
      kind={kind}
      title={title}
      subtitle={subtitle}
    />
  );
};

export default Toast;
